// React Imports
import { useNavigate, useLocation } from "react-router";

// Local Components
import S from "./ProfileTabs.module.scss";

// External Libraries
import C from "classnames";
import { TabView, TabPanel } from "primereact/tabview";

// Hooks and Helpers
import { buildRoute } from "sj-ui-toolkit/src/constants/routes";

export function ProfileTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: "Achievements",
      icon: "pi pi-trophy",
      path: buildRoute("User.routes.achievements.route"),
    },
    {
      label: "Certificates",
      icon: "pi pi-id-card",
      path: buildRoute("User.routes.certificates.route"),
    },
    { label: "History", icon: "pi pi-history", path: buildRoute("User.routes.history.route") },
    { label: "Notes", icon: "pi pi-clipboard", path: buildRoute("User.routes.notes.route") },
    { label: "Profile", icon: "pi pi-user", path: buildRoute("User.routes.profile.route") },
    { label: "Settings", icon: "pi pi-cog", path: buildRoute("User.routes.settings.route") },
  ];

  const pathname = location.pathname;
  const matchingIndex = tabs.findIndex(tab => pathname === tab.path);
  const defaultIndex = tabs.findIndex(tab => tab.label === "Profile");
  const activeIndex = matchingIndex !== -1 ? matchingIndex : defaultIndex;

  const handleTabChange = e => {
    const selectedTab = tabs[e.index];
    navigate(selectedTab.path);
  };

  return (
    <div className={S.root}>
      <TabView
        aria-label="Profile sections"
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
        panelContainerClassName={S.hiddenPanels}
      >
        {tabs.map((tab, index) => (
          <TabPanel
            key={tab.label}
            header={
              <div className={C(S.tab, { [S.active]: index === activeIndex })}>
                <i className={tab.icon} /> {tab.label.toUpperCase()}
              </div>
            }
          />
        ))}
      </TabView>
    </div>
  );
}
